// Unlike the DAWA field this replaces, there is no load-time health probe:
// autocomplete attaches immediately and the form degrades when a search
// actually fails, so a service dying mid-session is handled too.

import {
    createClient,
    parseDesignation,
    isTerminalRow,
    isRefinementRow
} from "./adressevaelger/client";

const DEBOUNCE_MS = 200;
const FIELD_PREFIX = "#order_delivery_address_attributes_";

// Excludes access_latitude / access_longitude: those hold the vejpunkt, which
// Adressevaelger does not expose, so nothing populates them any more.
const MIRROR_FIELDS = ["address_1", "zipcode", "city", "latitude", "longitude"];

const COORDINATE_FIELDS = ["latitude", "longitude"];

function field(name) {
    return $(FIELD_PREFIX + name);
}

$(function () {
    const input = document.getElementById("address_search");
    if (!input) return;

    const $input = $(input);
    const $wrapper = $input.closest(".address_search");
    const $error = $("#address_error_message");
    const $manualEntry = $("#address_manual_entry");

    const client = createClient({ token: $input.data("token") });

    const $suggestions = $('<ul class="address-autocomplete-suggestions d-none"></ul>');
    $input.after($suggestions);

    let degraded = false;
    let debounceTimer = null;
    let requestSequence = 0;
    let rows = [];

    // Sticky: a later successful search must not re-lock the fields under a
    // user who has started typing by hand.
    function enterDegradedEntry() {
        if (!degraded) {
            degraded = true;
            MIRROR_FIELDS.forEach((name) => field(name).removeAttr("readonly"));
            $error.removeClass("d-none");
            $manualEntry.removeClass("d-none");
            // The address is typed into address_1 now, so the `required` search
            // box must not block submission.
            $input.removeAttr("required");
        }
        hideSuggestions();
    }

    function hideSuggestions() {
        $suggestions.empty().addClass("d-none");
        rows = [];
    }

    function renderSuggestions(found) {
        rows = found;
        $suggestions.empty();

        if (!found.length) {
            $suggestions.addClass("d-none");
            return;
        }

        found.forEach((row, index) => {
            const label = row.titel || row.vejnavn || row.vejNavn || "";
            $("<li></li>")
                .addClass("address-autocomplete-suggestion")
                .attr("data-index", index)
                .text(label)
                .appendTo($suggestions);
        });

        $suggestions.removeClass("d-none");
    }

    function setAddressFields({ address, zip, city, lat, lon }) {
        field("address_1").val(address == null ? "" : address);
        field("zipcode").val(zip == null ? "" : zip);
        field("city").val(city == null ? "" : city);
        field("latitude").val(lat == null ? "" : lat);
        field("longitude").val(lon == null ? "" : lon);
    }

    function clearCoordinates() {
        COORDINATE_FIELDS.forEach((name) => field(name).val(""));
    }

    async function runSearch(text) {
        const sequence = (requestSequence += 1);

        try {
            const found = await client.search(text);
            if (sequence !== requestSequence) return; // a newer search has overtaken this one
            renderSuggestions(found);
        } catch (error) {
            console.error("Adressevaelger search failed:", error);
            enterDegradedEntry();
        }
    }

    // A street, not an address: narrow the query, populate nothing, look nothing up.
    function refineWith(row) {
        const text = row.titel || row.vejnavn || row.vejNavn || "";
        $input.val(text);
        hideSuggestions();
        runSearch(text);
    }

    async function selectTerminal(row) {
        $input.val(row.titel || "");
        hideSuggestions();

        let resolved;
        try {
            resolved = await client.lookup(row.type, row.id);
        } catch (error) {
            console.error("Adressevaelger lookup failed:", error);
            enterDegradedEntry();
            return;
        }

        if (resolved) {
            setAddressFields(resolved);
            return;
        }

        // Searchable but unresolvable (DAR status 4-5 house numbers 404). Let them
        // submit without coordinates rather than dead-ending them.
        const parsed = parseDesignation(row.titel);
        setAddressFields({ address: parsed.head, zip: parsed.zip, city: parsed.city, lat: null, lon: null });
        clearCoordinates();
    }

    $input.on("input", function () {
        const text = $input.val();

        clearTimeout(debounceTimer);
        if (!text || !text.trim()) {
            hideSuggestions();
            return;
        }

        debounceTimer = setTimeout(() => runSearch(text), DEBOUNCE_MS);
    });

    $suggestions.on("click", ".address-autocomplete-suggestion", function () {
        const row = rows[$(this).data("index")];
        if (!row) return;

        if (isRefinementRow(row)) {
            refineWith(row);
        } else if (isTerminalRow(row)) {
            selectTerminal(row);
        }
    });

    $manualEntry.on("click", function (event) {
        event.preventDefault();
        enterDegradedEntry();
        field("address_1").trigger("focus");
    });

    $(document).on("click", function (event) {
        if (!$wrapper.length || $wrapper.has(event.target).length || $wrapper.is(event.target)) return;
        hideSuggestions();
    });
});
